// Google Analytics (GA4) — SADECE pencere/sekme geçişlerini izlemek için kullanılır, başka hiçbir
// veri (kullanıcı bilgisi, işlem verisi, form içeriği vb.) gönderilmez. gtag, public/index.html'de
// zaten yüklenmiş olan GA4 script'i tarafından window'a eklenir (send_page_view:false ile otomatik
// ilk sayfa görüntüleme kapatılmıştır — tüm "page_view" olayları buradan elle tetiklenir).
function slugify(name) {
  return '/' + String(name)
    .toLowerCase()
    .replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ş/g, 's')
    .replace(/ı/g, 'i').replace(/ö/g, 'o').replace(/ç/g, 'c')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

// name: kullanıcıya gösterilen ekran/pencere adı (ör. "Ayarlar - Risk", "Backtest - Parametre Taraması").
export function trackPageView(name) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function' || !name) return;
  window.gtag('event', 'page_view', {
    page_title: name,
    page_path: slugify(name),
    page_location: window.location.href,
  });
}
